import Swiper from 'swiper/bundle';

export default function () {
    return new Swiper('.slider-swiper', {
        lazy: true,
        loop: true,
        updateOnImagesReady: false,
        simulateTouch: false,
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true,
            renderBullet(index, className) {
                return `<span class="${className} dot"><div class="active-border"><div class="circle"></div></div></span>`;
            },
        },
        navigation: {
            prevEl: '.slider .slider__nav__prev',
            nextEl: '.slider .slider__nav__next',
        },
        autoplay: {
            delay: 4700,
        },
    });
}
